<template>
  <div>
  <div id="homePage-4"  v-if=" this.$i18n.locale == 'zh'">
    <div class="part-title">
    <h3>{{ msg }}</h3>
    </div>
    <dl>
      <dt>软件开发：</dt><dd>虚拟现实技术应用、软件技术、信息安全技术应用。</dd>
      <dt>技术服务：</dt><dd>算法分析与设计、机器人学、控制理论、传感器技术。</dd>
      <dt>技术合作：</dt><dd>工业互联网平台、工业数据采集与传输、理论教学和实践指导。</dd>
</dl>
  </div>
  <div id="homePage-4"  v-if=" this.$i18n.locale == 'en'">
    <div class="part-title">
    <h3>Cooperation</h3>
    </div>
    <dl>
      <dt>Software Development：</dt><dd>commissioned and collaborative development</dd>
      <dt>Technical Service：</dt><dd>Provide technical theoretical support, algorithms, and operation and maintenance。</dd>
      <dt>Technical Cooperation：</dt><dd>Operations Management Partner。</dd>
</dl>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageFour',
  data () {
    return {
      msg: '技术合作'
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-4 {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  background: url("~assets/img/banner/bg_diandian.png") center no-repeat,
              linear-gradient(to right,#fff 0,#f1f2f6 100%);
  background-size: cover;
}
.part-title {
  position: relative;
  width: 100%;
  margin-bottom: 65px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;
  h3 {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #072c69;
  }
  p {
    font-size: 16px;
    color: #acadb3;
  }
}
dl{
   width: 60%;
    margin: 2rem auto;
    text-align: left;
    display: inline-block;
    list-style-type: none;
    font-size: 20px;
  }
dt{
  padding-top:40px;
}
  dd {
  font-size: 20px;
  display: block;
  margin-left: 40px;
}
</style>
